export default "__VITE_ASSET__Boyce1Wk__"